import { createFileRoute } from '@tanstack/react-router';
import { AppCategory } from 'typescript/enums/AppCategory';

import { getSoureAppsOptions } from 'hooks/data/useSourceAppData';

import { SuppliersView } from 'views/SuppliersView';

export const Route = createFileRoute('/_auth/_layout/suppliers/')({
  component: SuppliersView,
  loader: async ({ context: { queryClient } }) => {
    const data = await queryClient.ensureQueryData(getSoureAppsOptions());

    return data.filter((app) => {
      return [
        AppCategory.TOUR_OPERATORS,
        AppCategory.CRUISE_LINES,
        AppCategory.ACCOMMODATIONS,
        AppCategory.RAIL_AND_TRANSPORT,
        AppCategory.PARTNERS,
      ].some((id) => {
        return app.categories.find((cat) => {
          return cat.categoryId === Number(id);
        });
      });
    });
  },
});
